(() => {
  const MOBILE_MQ = '(max-width: 749px)';
  const STICKY_ID = 'CartCheckoutSticky';
  const TOTALS_SELECTOR = '#main-cart-footer .totals__wrapper';
  const CTAS_SELECTOR = '#main-cart-footer .cart__ctas';
  const CLASS_VISIBLE = 'is-visible';
  const CLASS_ACTIVE = 'cart-checkout-sticky-active';

  let mobileMq;
  let rafId = 0;

  function getSticky() {
    return document.getElementById(STICKY_ID);
  }

  function setStickyVisible(visible) {
    const sticky = getSticky();
    if (!sticky) return;

    sticky.hidden = !visible;
    sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
    sticky.classList.toggle(CLASS_VISIBLE, visible);
    document.documentElement.classList.toggle(CLASS_ACTIVE, visible);
  }

  function updateVisibility() {
    const sticky = getSticky();
    if (!sticky || !mobileMq?.matches) {
      setStickyVisible(false);
      return;
    }

    const totals = document.querySelector(TOTALS_SELECTOR);
    const ctas = document.querySelector(CTAS_SELECTOR);
    if (!totals || !ctas) {
      setStickyVisible(false);
      return;
    }

    const vh = window.innerHeight;
    const totalsRect = totals.getBoundingClientRect();
    const ctasRect = ctas.getBoundingClientRect();

    // Show only after totals enter view, and only while in-page checkout is still fully below the fold
    const reachedTotals = totalsRect.top < vh;
    const scrolledPastCtas = ctasRect.bottom <= 0;
    const inPageCheckoutInView = ctasRect.top < vh;

    setStickyVisible(reachedTotals && !scrolledPastCtas && !inPageCheckoutInView);
  }

  function onScrollOrResize() {
    if (rafId) return;
    rafId = requestAnimationFrame(() => {
      rafId = 0;
      updateVisibility();
    });
  }

  function init() {
    mobileMq = window.matchMedia(MOBILE_MQ);

    const onMqChange = () => updateVisibility();
    if (mobileMq.addEventListener) {
      mobileMq.addEventListener('change', onMqChange);
    } else if (mobileMq.addListener) {
      mobileMq.addListener(onMqChange);
    }

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);

    document.addEventListener('cart:updated', () => requestAnimationFrame(updateVisibility));
    document.addEventListener('cart-items:updated', () => requestAnimationFrame(updateVisibility));

    const footer = document.getElementById('main-cart-footer');
    if (footer && 'MutationObserver' in window) {
      new MutationObserver(() => onScrollOrResize()).observe(footer, {
        childList: true,
        subtree: true,
      });
    }

    updateVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
